import {FOOD_BENEFIT_STATES} from 'common/domain/constants';
import {CARD_STATUS, MODAL_STATES, MODAL_ACTIONS} from 'food-benefit.module/common/domain/constants';
import {MODALS} from 'common/domain/constants';

import PeriodsHelper from 'food-benefit.module/common/domain/helpers/periodsHelper';
import MessageFormatter from 'food-benefit.module/common/domain/formatters/messageFormatter';

class BenefitRequestListController {
  constructor(foodBenefitService,
              FoodBenefitUserDataService,
              $translate,
              loadingMobileService,
              floatingActionButtonsService) {
    'ngInject';
    this.translate = $translate;
    this.foodBenefitService = foodBenefitService;
    this.FoodBenefitUserDataService = FoodBenefitUserDataService;
    this.loadingMobileService = loadingMobileService;
    this.requestsToSend = [];
    this.periodsHelper = new PeriodsHelper();
    this.messageFormatter = new MessageFormatter();
    this.floatingActionButtonsService = floatingActionButtonsService;
  }

  get modal() {
    return $(MODALS.BENEFIT_REQUEST);
  }

  $onInit() {
    this.managerId = this.FoodBenefitUserDataService.getEmployee().userId;
    this._translate();

    if (this.isMobileApp) {
      this.floatingActionButtons = this.getFloatingActionButtons();
    }
  }

  isEmpty() {
    return !this.periods.some((period) => {
      return period.status !== CARD_STATUS.APPROVE;
    });
  }

  getApproveAllClasses() {
    return {
      invisible: this.periods.length === 1
    };
  }

  onProcessPeriod({request}) {
    if (request.status === CARD_STATUS.REJECT) {
      this.openModalReject(request);
    } else if (request.status === CARD_STATUS.APPROVE) {
      this.loadPeriodToSend(request);
    }
  }

  openModalIsDelegated() {
    this.modalState = MODAL_STATES.isDelegated;
    this.modal.modal('show');
  }

  openModalAcceptAll() {
    this.modalState = MODAL_STATES.managerListConfirmAll;
    this.modal.modal('show');
  }

  openModalReject(request) {
    this.modalState = MODAL_STATES.isManagerRejecting;
    this.requestModal = request;
    this.modal.modal('show');
  }

  loadPeriodToSend(request) {
    let rawPeriod = Array(request);
    this.requestsToSend = [];
    this.requestsToSend.push(request);
    this.requestsToSend = this.formatPeriodsToSendRequest(this.requestsToSend);
    this.send(this.requestsToSend, rawPeriod, this.managerId);
  }

  setStatus($event) {
    this.modalAction = $event.status;

    if (!this.modalAction) {
      return;
    }

    if ($event.status === MODAL_ACTIONS.CANCEL) {
      this.modal.modal('hide');
    }

    if ($event.status === MODAL_ACTIONS.REJECT) {
      this.loadPeriodToSend($event.request);
    }

    if ($event.status === MODAL_ACTIONS.APPROVE_ALL) {
      this.onAcceptAll();
    }
  }

  getRequestCount() {
    return this.periods.length;
  }

  onAcceptAll() {
    this.rawPeriods = this.periods;
    this.requestsToSend = this.periods;
    this.requestsToSend = this.setAllAsSuccess(this.requestsToSend);
    let formattedPeriods = this.formatPeriodsToSendRequest(this.requestsToSend);
    this.send(formattedPeriods, this.rawPeriods, this.managerId);
  }

  formatPeriodsToSendRequest(periods) {
    let periodsProcessed = [];
    periods.forEach(period => {
      periodsProcessed.push(this.transformPeriodToRequest(period));
    });
    return periodsProcessed;
  }

  transformPeriodToRequest(period) {
    return {
      employeeId: period.employeeId,
      enjoymentYear: period.enjoymentYear,
      enjoymentMonth: period.enjoymentMonth,
      enjoymentDays: period.enjoymentDays,
      remarks: period.remarks,
      status: period.status,
    };
  }

  send(request, rawPeriods, managerId) {
    this.loadingMobileService.show();
    this.foodBenefitService.validateFoodBenefits(request, managerId).then(() => {
      this._buildModalMessage(request, rawPeriods);
      this.modalState = this.getModalStateOnSuccess(this.modalState);
      this.modal.modal('show');
      this.periods = [];
      this.requestDataUpdate();
    }, (err) => {
      this.errorMsg = err.data.message;
      this.setAllAsRequested(this.requestsToSend);
      this.modalState = MODAL_STATES.failed;
      this.modal.modal('show');
    }).finally(() => this.loadingMobileService.hide());
  }

  getModalStateOnSuccess(currentModalState) {
    if (currentModalState === MODAL_STATES.isManagerRejecting) {
      return MODAL_STATES.approveReject;
    }

    return MODAL_STATES.approve;
  }

  setAllAsSuccess(requests) {
    requests.forEach(request => {
      request.status = FOOD_BENEFIT_STATES.approve;
    });
    this.requestModal = requests;
    return requests;
  }

  setAllAsRequested(requests) {
    requests.forEach(request => {
      request.status = FOOD_BENEFIT_STATES.requested;
    });
    this.requestModal = requests;
    return requests;
  }

  _buildModalMessage(request, rawPeriods) {
    if (request.length > 1) {
      this.errorMsg = this.getApproveAllMessage(request, rawPeriods);
    } else {
      const onlyRequest = request[0];
      const period = this.periodsHelper.findPeriod(onlyRequest, rawPeriods);
      this.errorMsg = this.messageFormatter.getApproveSinglePeriodMessage(period, this.msgString, this.positiveDaysDifferenceText, this.negativeDaysDifferenceText);
    }
  }

  getApproveAllMessage(requests, rawPeriods) {
    let message = '';

    message += this.messageFormatter.getApprovePeriodsInitialMessage(requests, this.allRequestApprovedText);

    requests.forEach(request => {
      const period = this.periodsHelper.findPeriod(request, rawPeriods);
      message += this.messageFormatter.getApprovePeriodMessage(period,
                                                                this.msgString,
                                                                this.positiveDaysDifferenceText,
                                                                this.negativeDaysDifferenceText,
                                                                this.isMobileApp);
    });

    return message;
  }

  _translate() {
    this.translate('FOOD_BENEFIT.MODAL_REJECT_REQUEST.JOURNEYS').then((translation) => {
      this.msgString = translation;
    });

    this.translate('FOOD_BENEFIT.BENEFIT_REQUEST_CARD.POSITIVE_REQUESTED_DAYS').then((translation) => {
      this.positiveDaysDifferenceText = translation;
    });

    this.translate('FOOD_BENEFIT.BENEFIT_REQUEST_CARD.NEGATIVE_REQUESTED_DAYS').then((translation) => {
      this.negativeDaysDifferenceText = translation;
    });

    this.translate('FOOD_BENEFIT.MODAL_APPROVE_ALL.OK').then((translation) => {
      this.allRequestApprovedText = translation;
    });
  }

  showSendAllRequest() {
    const requestsEmpty = this.isEmpty();
    return this.isMobileApp && !requestsEmpty && !this.isInputFocused();
  }

  isInputFocused() {
    return this.floatingActionButtonsService.isFocused;
  }

  getFloatingActionButtons() {
    return [
      {
        literal: 'GLOBALS.BUTTON_ACTION.ACCEPT_ALL'
      }
    ];
  }
}

export default BenefitRequestListController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestList/benefitRequestList.controller.js